import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const LeasingExpensesSummaryComponent = ({ t, items, offerCurrency }) => {
  return (
    <>
      <Grid container>
        {items.map((item, idx) => {
          return (
            <Grid item xs={12} sm={6} key={idx}>
              <strong id={'LeasingExpensesSummaryComponent_item_' + idx + '_name'}>{item.document.leasingExpenseName}: </strong>
              <span id={'LeasingExpensesSummaryComponent_item_' + idx + '_value'}>
                {t('DECIMAL2', { number: item.document.currencyValue })} {offerCurrency}
              </span>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

LeasingExpensesSummaryComponent.propTypes = {
  t: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  offerCurrency: PropTypes.string
};

export default withTranslation()(LeasingExpensesSummaryComponent);
